import reviewsRow from '~/assets/js/constants/reviewsRow.js'

const getReviewsRow = ($this) => {
  const aggregated = $this.$pinia.state.value.review.aggregated
  const count = $this.$tn(aggregated.count)
  const rating = $this.$tn(aggregated.averageStars, 1)
  const recommendRate = $this.$tp(
    aggregated.recommendRate
  )

  return reviewsRow({ count, rating, recommendRate })
}

export const resolveContentLoopRows = ($this) => {
  return $this.rows.map((row) => {
    if (row.type === 'reviews_row') {
      return getReviewsRow($this)
    }
    return row
  })
}
